export default __webpack_public_path__ + "static/media/robot.8ebd01bb.jpg";